export default __webpack_public_path__ + "static/media/box-plot.38613871.svg";